import { render, staticRenderFns } from "./ProductPictureGallery.vue?vue&type=template&id=23ee9b0a&"
import script from "./ProductPictureGallery.vue?vue&type=script&lang=js&"
export * from "./ProductPictureGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports